export const GET_COMPANY_APPLICANT_PROFILE_REQUEST =
  "GET_COMPANY_APPLICANT_PROFILE_REQUEST";
export const GET_COMPANY_APPLICANT_PROFILE_RESPONSE =
  "GET_COMPANY_APPLICANT_PROFILE_RESPONSE";
export const CLEAR_COMPANY_APPLICANT_PROFILE = "CLEAR_COMPANY_APPLICANT_PROFILE";
